/**
 * The element the page scrolls in. The window never scrolls: MainLayout's
 * content area does. Sticky table headers (antd Table sticky.getContainer)
 * need that element, not the window.
 */
import { createContext, useCallback, useContext } from "react";

export const ScrollContainerContext = createContext(null);

/** Returns a getter for the scroll element (the window outside MainLayout). */
export function useScrollContainer() {
  const ref = useContext(ScrollContainerContext);
  return useCallback(() => ref?.current ?? window, [ref]);
}
